import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import Card from '@components/Card/Card';
import urls from '@routes/urls';

const DietarySupplementInquiryCard: FC = () => {
  const { t } = useTranslation();

  return (
    <Card
      icon="/images/img-dietarysupplement-circle.svg"
      title={t('dashboardCards.dietarySupplementInquiry.title')}
      description={t('dashboardCards.dietarySupplementInquiry.description')}
      link={{
        title: t('dashboardCards.dietarySupplementInquiry.linkTitle'),
        routerLink: urls.inquiryDraft,
      }}
    />
  );
};

export default DietarySupplementInquiryCard;
